declare namespace $ {

	export class $bog_lk_avatar extends $mol_button_open {
		entity( ): any
	}
	
}

//# sourceMappingURL=avatar.view.tree.d.ts.map